import React from "react";
import Title from "../layouts/Title";
import Reveal from "../layouts/Reveal";
import { iconFor } from "../layouts/techIcons";
import { skillGroups } from "../../constants";

const Skills = () => {
  return (
    <section id="skills" className="sectionWrap">
      <Title title="My Toolbox" des="Skills & Technologies" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {skillGroups.map(({ title, skills }, index) => (
          <Reveal key={title} delay={index * 0.08}>
            <div className="card p-6 md:p-8 h-full">
              <h3 className="text-lg font-semibold text-white font-titleFont mb-5 flex items-center gap-3">
                <span className="w-2 h-6 rounded-full bg-gradient-to-b from-designColor to-[#ff8a5c]"></span>
                {title}
              </h3>
              <div className="flex flex-wrap gap-3">
                {skills.map((skill) => (
                  <span
                    key={skill}
                    className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-black/25 border border-white/5 text-gray-300 text-sm hover:border-designColor/50 hover:text-white hover:-translate-y-0.5 duration-300"
                  >
                    <span className="text-designColor text-base">{iconFor(skill)}</span>
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Skills;
